import {
  FormControl,
  FormLabel,
  Input,
  InputGroup,
  InputProps,
  InputRightElement,
} from "@chakra-ui/react";

const PercentField = ({
  label,
  value,
  onChange,
  isInvalid,
  cy,
  variant = "primary",
  disabled = false,
}: {
  label?: string;
  value: string;
  onChange: (value: string) => void;
  isInvalid?: boolean;
  cy?: string;
  variant?: string;
  disabled?: boolean;
}) => {
  return (
    <FormControl>
      {label && <FormLabel>{label}</FormLabel>}
      <PercentInput
        cy={cy}
        value={value}
        onValueChange={value => onChange(value)}
        isInvalid={isInvalid}
        isDisabled={disabled}
      />
    </FormControl>
  );
};

export interface PercentInputProps extends InputProps {
  cy?: string;
  variant?: string;
  onValueChange?: (value: string) => void;
}

export function PercentInput({ cy, onChange, onValueChange, ...props }: PercentInputProps) {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    let newValue = e.target.value;

    if (newValue === "") {
      onValueChange?.("");
      onChange?.(e);
      return;
    }

    onValueChange?.(newValue);
    onChange?.(e);
  };

  return (
    <InputGroup>
      <Input
        data-cy={cy}
        pr="1.75rem"
        placeholder="0.00"
        min="0"
        max="100"
        step="0.01"
        variant="primary"
        type="number"
        value={props.value}
        {...props}
        onChange={handleChange}
      />
      {props.variant === "scenario" ? (
        <InputRightElement
          pr="1rem"
          pointerEvents="none"
          children="%"
          w="fit-content"
          fontSize="14px"
          height="36px"
          color={props.isDisabled ? "gray.200" : "secondary"}
        />
      ) : (
        <InputRightElement pr="1rem" pointerEvents="none" children="%" w="fit-content" />
      )}
    </InputGroup>
  );
}

export default PercentField;
